<div class="m-8" [formGroup]="form">
  <div class="flex justify-content-sb align-baseline">
    <h1 data-cy = "dashboardHeader">Analytics Overview</h1>

    <custom-date-select-wrapper
      class="mb-2"
      [defaultDate]="'Year'"
      (selectedDateHandler)="setInterval('stats', $event)"
      (customDateHandler)="setCustomInterval('stats', $event)"
    ></custom-date-select-wrapper>
  </div>
  <sociuu-statistics [statistics]="statistics" [currencySymbol]="clientCurrencySymbol" [statsNum]="statsNum"></sociuu-statistics>

  <div class="flex justify-content-sb align-baseline mt-6">
    <h1>Performance Metrics</h1>

    <custom-date-select-wrapper
      class="mb-2"
      [defaultDate]="'Year'"
      (selectedDateHandler)="setInterval('performance', $event)"
      (customDateHandler)="setCustomInterval('performance', $event)"
    ></custom-date-select-wrapper>
  </div>

  <div class="flex margin-align">
    <div class="f-item pr-4 w-50">
      <sociuu-top-performing-groups
        [topPerformingGroups]="topPerformingGroups"
        [loadingText]="loadingTextTopPerformingGroups"
      ></sociuu-top-performing-groups>
    </div>
    <div class="f-item pl-4 w-50">
      <sociuu-line-chart
        [chartTitle]="adoptionRateChart.chartTitle"
        [chartData]="adoptionRateChart.chartData"
        [title]="adoptionRateChart.title"
        [labels]="adoptionRateChart.labels"
        [series]="adoptionRateChart.series"
        [loadingText]="loadingTextAdoptionRate"
      ></sociuu-line-chart>
    </div>
  </div>

  <div class="flex margin-align mt-8">
    <div class="f-item pr-4 w-50">
      <sociuu-line-chart
        [chartTitle]="topEngagementChart.chartTitle"
        [chartData]="topEngagementChart.chartData"
        [title]="topEngagementChart.title"
        [labels]="topEngagementChart.labels"
        [series]="topEngagementChart.series"
        [loadingText]="loadingTextTopEngagement"
      ></sociuu-line-chart>
    </div>
    <div class="f-item pl-4 w-50">
      <sociuu-line-chart
        [chartTitle]="frequencyRatioChart.chartTitle"
        [chartData]="frequencyRatioChart.chartData"
        [title]="frequencyRatioChart.title"
        [labels]="frequencyRatioChart.labels"
        [series]="frequencyRatioChart.series"
        [xAxisType]="frequencyRatioChart.xAxisType"
        [loadingText]="loadingTextFrequencyRatio"
        [tickAmount]="tickAmount"
      ></sociuu-line-chart>
    </div>
  </div>
</div>
